import {
  faBan,
  faBolt,
  faUser,
  type IconDefinition
} from '@fortawesome/pro-regular-svg-icons';

import { PRIORITY } from '@/constants/common';

import {
  type AIResponseActionConfig,
  AIResponseActionModeEnum
} from './AIResponseActionMatrix.types';

export const AI_RESPONSE_PRIORITIES = [
  PRIORITY.P1,
  PRIORITY.P2,
  PRIORITY.P3,
  PRIORITY.P4
] as const;

export const AI_RESPONSE_DEFAULT_MODES: AIResponseActionConfig = {
  invalidate_session_token: {
    [PRIORITY.P1]: AIResponseActionModeEnum.AGENTIC,
    [PRIORITY.P2]: AIResponseActionModeEnum.AGENTIC,
    [PRIORITY.P3]: AIResponseActionModeEnum.AGENTIC,
    [PRIORITY.P4]: AIResponseActionModeEnum.AGENTIC
  },
  host_isolation: {
    [PRIORITY.P1]: AIResponseActionModeEnum.AGENTIC,
    [PRIORITY.P2]: AIResponseActionModeEnum.AGENTIC,
    [PRIORITY.P3]: AIResponseActionModeEnum.MANUAL,
    [PRIORITY.P4]: AIResponseActionModeEnum.MANUAL
  },
  identity_isolation: {
    [PRIORITY.P1]: AIResponseActionModeEnum.AGENTIC,
    [PRIORITY.P2]: AIResponseActionModeEnum.AGENTIC,
    [PRIORITY.P3]: AIResponseActionModeEnum.AGENTIC,
    [PRIORITY.P4]: AIResponseActionModeEnum.AGENTIC
  }
};

export const AI_RESPONSE_MODE_OPTIONS: {
  value: AIResponseActionModeEnum;
  label: string;
  icon: IconDefinition;
}[] = [
  {
    value: AIResponseActionModeEnum.DISABLED,
    label: 'Disabled',
    icon: faBan
  },
  { value: AIResponseActionModeEnum.MANUAL, label: 'Manual', icon: faUser },
  {
    value: AIResponseActionModeEnum.AGENTIC,
    label: 'Agentic',
    icon: faBolt
  }
];
